import {Component, OnInit} from '@angular/core';
import {CrudConfig} from '@ngx-ivengi/crud';
import {DatagridEmployeeComponent} from '../datagrid/datagrid-employee-component';
import {DatagridService} from '../datagrid/datagrid.service';
import {UIRouter} from '@uirouter/angular';

@Component({
  selector: 'app-archive-employee-overview',
  templateUrl: '../datagrid/datagrid.component.html'
})
export class BuildingChannelOverviewComponent extends DatagridEmployeeComponent implements OnInit {

  public searchEnabled: boolean = true;
  public assignmentStatusFilterId: number = this.crudConfig.getFilterId();
  private buildingFilterId: number = this.crudConfig.getFilterId();

  constructor(
    datagridService: DatagridService,
    private crudConfig: CrudConfig,
    private router: UIRouter
  ) {
    super(datagridService);
  }

  public ngOnInit(): void {
    super.ngOnInit();

    if(!this.router.stateService.params.assignment) {
      this.requestParams
        .addFilterParam({
          id: this.buildingFilterId,
          key: 'Channel.buildingId',
          operator: 'eq',
          value: this.router.stateService.params.buildingId,
        });
    }

    this.datagridSearchComponent.config.filters.building.value = this.router.stateService.params.buildingId;
    this.datagridSearchComponent.config.filters.building.enabled = false;
    this.datagridSearchComponent.config.filters.owner.enabled = false;
    this.datagridSearchComponent.config.filters.throughputType.enabled = false;
    this.datagridSearchComponent.config.filters.dateFrom.enabled = false;
    this.datagridSearchComponent.config.filters.dateTill.enabled = false;

    this.datagridListComponent.config.enabledColumns = [
      'menu',
      'floor.name',
      'channel.recordingFormat',
      'channel.label',
      'channel.throughputCount',
      'channel.dimension',
      'channel.location',
      'channel.finish',
      'roomFrom.name',
      'roomTo.name'
    ];

    this.datagridListComponent.config.throughputSubgrid.enabled = false;
    this.datagridListComponent.config.exportation.enabled = true;
    this.datagridListComponent.config.bulkEdit.enabled = true;
    this.datagridListComponent.config.loadProfile = true;

    this.datagridListComponent.config.searchOnInit = true;

    this.onBuildingSelect();
  }
}




// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/building/building-channel-overview.component.ts